function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcDisabledMinus = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3196",
    d: "M18 0A18 18 0 1 1 0 18 18 18 0 0 1 18 0z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 5809",
    transform: "translate(8 17)",
    style: {
      fill: "#fff",
      stroke: "#333",
      strokeWidth: 2
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.99,
    height: 2.221,
    rx: 1.111,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 17.99,
    height: 0.221,
    rx: 0.111,
    style: {
      fill: "none"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcDisabledMinus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-disabledMinus.457aa310f90ce50cb7141413119e0186.svg";